import { providers } from '../../providers';
import { cool } from '../cool';
import type { VideoModelEntry } from '../types';
import {
    rmbCost480p, usdCost480p, rmbCost720p, usdCost720p, rmbCost1080p, usdCost1080p,
    rmbRefCost480p, usdRefCost480p, rmbRefCost720p, usdRefCost720p, rmbRefCost1080p, usdRefCost1080p,
    rmbCost480pFast, usdCost480pFast, rmbCost720pFast, usdCost720pFast,
    rmbRefCost480pFast, usdRefCost480pFast, rmbRefCost720pFast, usdRefCost720pFast,
    rmbCost480pMini, usdCost480pMini, rmbCost720pMini, usdCost720pMini,
    rmbRefCost480pMini, usdRefCost480pMini, rmbRefCost720pMini, usdRefCost720pMini,
} from './seedance-pricing';

// 系数
const COST_FACTOR = 1.5;

export const coolModels: VideoModelEntry[] = [
    {
        id: 'seedance-2.0-cool',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: cool('seedance-2.0-cool'),
                modelBackup: [cool('dreamina-seedance-2.0-cool')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdRefCost1080p * COST_FACTOR;
                        return totalDur * usdRefCost1080p * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdCost1080p * COST_FACTOR;
                        return totalDur * usdCost1080p * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbRefCost1080p * COST_FACTOR;
                        return totalDur * rmbRefCost1080p * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbCost1080p * COST_FACTOR;
                        return totalDur * rmbCost1080p * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p'],
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p'],
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p'],
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first', 'first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    {
        id: 'seedance-2.0-fast-cool',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: cool('seedance-2.0-fast-cool'),
                modelBackup: [cool('dreamina-seedance-2.0-fast-cool')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720pFast * COST_FACTOR;
                        return totalDur * usdRefCost720pFast * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720pFast * COST_FACTOR;
                        return totalDur * usdCost720pFast * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720pFast * COST_FACTOR;
                        return totalDur * rmbRefCost720pFast * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720pFast * COST_FACTOR;
                        return totalDur * rmbCost720pFast * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first', 'first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    {
        id: 'seedance-2.0-mini-cool',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: cool('seedance-2.0-mini-cool'),
                modelBackup: [cool('dreamina-seedance-2.0-mini-cool')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720pMini * COST_FACTOR;
                        return totalDur * usdRefCost720pMini * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720pMini * COST_FACTOR;
                        return totalDur * usdCost720pMini * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720pMini * COST_FACTOR;
                        return totalDur * rmbRefCost720pMini * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720pMini * COST_FACTOR;
                        return totalDur * rmbCost720pMini * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first', 'first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
]